"use client";

export default function MaintenancePlan() {
  const items = [
    "Inspection of all windows and sliding doors",
    "Track cleaning and debris removal",
    "Lubrication of rollers and hinges",
    "Tightening of loose hardware",
    "Weatherstripping condition check",
    "Written report with recommendations",
  ];

  return (
    <section className="bg-white py-16 px-4 md:px-6">
      <div className="max-w-[1080px] mx-auto">
        <h2 className="text-xl md:text-[28px] font-bold text-secondary text-center mb-8">
          What&apos;s Included in an Annual Tune-Up
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {items.map((item) => (
            <div key={item} className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-checkbox-circle-fill text-primary text-lg" />
              </div>
              <p className="text-sm text-gray-700">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}